module.exports = __webpack_public_path__ + "img/about_a04.3b822f6c.svg";